import * as React from 'react'
import clsx from 'clsx'
import { SxProps, sx as sxFunc } from '../sx'
import style from './index.module.scss'

export interface DialogActionsClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to the root element unless `disableSpacing={true}`. */
  spacing: string
}

export interface DialogActionsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the component.
   */
  children?: React.ReactNode
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<DialogActionsClasses>
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing?: boolean
}

export const DialogActions = React.forwardRef<
  HTMLDivElement,
  DialogActionsProps
>(function DialogActions(props, ref) {
  const { className, classes, disableSpacing = false, sx, ...other } = props

  return (
    <div
      className={clsx(
        style.root,
        classes?.root,
        !disableSpacing && [classes?.spacing, style.spacing],
        className,
        sxFunc(sx)
      )}
      ref={ref}
      {...other}
    />
  )
})
